import { useFetchApiGet } from '@stagapps/redux-utils'
import { Alert, Typography } from 'antd'
import { useEffect } from 'react'

import apiCall from 'app/apiCalls/verification/getUserIdentifications'
import ErrorMessage from 'common/ui/ErrorMessage'
import LoadingSpinner from 'common/ui/LoadingSpinner'
import UICard from 'common/ui/display/UICard'
import EditKYCForm from './EditKYCForm'
import KYCSteps from './KYCSteps'

const { Title } = Typography

function EditKYCPage() {
  const { data, load, isLoading, error, refresh } = useFetchApiGet(apiCall, {
    resourceName: 'data'
  })

  useEffect(() => {
    load()
  }, [])

  if (isLoading) {
    return <LoadingSpinner />
  }

  if (!!error) {
    return <ErrorMessage errors={error} />
  }

  return (
    <div>
      <KYCSteps current={2} />
      <UICard title={'Kiểm tra thông tin'}>
        <div className="flex flex-col gap-4">
          <Alert
            message="Các thông tin này được sử dụng để mở tài khoản giao dịch với các
            công ty quỹ. Vui lòng kiểm tra và xác nhận."
            type="info"
            showIcon
          />
        </div>
        <EditKYCForm initialValues={data} />
      </UICard>
    </div>
  )
}

export default EditKYCPage
